<!--  -->
<template>
  <div class="course-list">
    <h2 class="course-name">
      <span></span><b>{{ courseInfo.productName }}</b>
    </h2>
    <div class="sku-name" v-if="!courseInfo.productSpecJson">
      <div class="tabSelected">单品<img  :src="checkIcon" alt="checkIcon" /></div>
    </div>
    <div class="sku-name" v-else v-for="(item, n) in productSpecJson" :key="n">
      <span>{{ item.name }}</span>
      <div
        v-for="(list, index) in item.options"
        @click="chooseSkuInfo(list.name, n, $event, index, list.isShow)"
        :class="{ tabItem: true, tabSelected: subIndex[n] == index, noneActive: !list.isShow }"
        :key="index"
      >
        {{ list.name }}<img v-if="subIndex[n] == index" :src="checkIcon" alt="checkIcon" />
      </div>
    </div>
  </div>
</template>

<script>
import checkIcon from '@/assets/img/components/courseDetail/checkIcon.png';

export default {
  components: {},
  data() {
    return {
      checkIcon,
      selectedIndex: 0,
      productSpecJson: [], // 展示在页面的sku规格
      iconChecked: checkIcon, // sku选中状态icon
      selectArr: [], // 选中的值
      shopItemInfo: {}, // 存放要和选中的值进行匹配的数据
      subIndex: [], // 是否选中
      someOne: null, // 可用的一条sku，用于展示默认的sku
    };
  },
  props: {
    courseInfo: {
      type: Object,
      default: () => {},
    },
  },
  computed: {},
  watch: {},
  methods: {
    // 选中sku属性
    chooseSkuInfo(item, n, event, index, canClick) {
      if (!canClick) {
        return false;
      }
      if (this.selectArr[n] !== item) {
        [this.selectArr[n], this.subIndex[n]] = [item, index];
      } else {
        [this.selectArr[n], this.subIndex[n]] = ['', '-1'];
      }
      this.findItem(item);
      this.checkItem();
      return true;
    },
    findItem(item) {
      let res = null;
      try {
        this.courseInfo.productSkuOptions.forEach((ele) => {
          const specJson = JSON.parse(ele.specJson);
          specJson.forEach((list) => {
            if (list.value === item && ((ele.isSetStock === 1 && ele.availableStock > 0) || ele.isSetStock === 0)) {
              res = ele;
              throw Error();
            }
          });
        });
      } catch (error) {
        //
      }
      // console.log(res, 444);
      this.setDefault([res]);
    },
    checkItem() {
      const self = this;
      const result = this.selectArr; // 定义数组储存被选中的值
      for (let i = 0; i < this.productSpecJson.length; i += 1) {
        result[i] = self.selectArr[i] ? self.selectArr[i] : '';
      }
      if (this.productSpecJson) {
        this.productSpecJson.forEach((element, i) => {
          const last = result[i];
          element.options.forEach((k) => {
            result[i] = k.name;
            Object.assign(k, { isShow: self.someOne ? self.isMay(result) : false }); // isShow来判断是否可以选择})
            if (i === 0) {
              const filterRes = this.courseInfo?.productSkuOptions.filter((item) => !(item.isSetStock === 1 && item.availableStock === 0));
              const flag = filterRes.find((item) => JSON.parse(item.specJson).find((child) => child.value === k.name));
              Object.assign(k, { isShow: !!flag });
            }
            // if (i === 0 && this.productSpecJson.length > 1 && this.courseInfo?.productSkuOptions?.length > 1) {
            //   Object.assign(k, { isShow: true });
            // }
          });
          result[i] = last; // 还原，目的是记录点下去那个值
        });
      }
      if (this.shopItemInfo[result]) {
        this.sendParentSkuId(this.shopItemInfo[result]);
      }
      self.$forceUpdate(); // 重绘
    },
    // 能否被选中
    isMay(result) {
      for (let k = 0; k < result.length; k += 1) {
        if (result[k] === '') {
          return true;
        }
      }
      // 校验list中是否有此条sku
      if (result && !this.shopItemInfo[result]) {
        return false;
      }
      // 库存校验
      return !(
        this.shopItemInfo[result].isSetStock === 1 && this.shopItemInfo[result].availableStock === 0
      );
    },
    // 修改数据结构,将选中的值作为key，以方便和选中之后的值进行匹配
    modifySkuRespVOList() {
      const { productSkuOptions, productSpecJson } = this.courseInfo;
      if (!productSpecJson && !productSkuOptions) return;
      if (!productSpecJson) {
        this.setDefault(productSkuOptions);
        return;
      }
      productSkuOptions.forEach((item) => {
        if (this.$route.path === '/groupProgress') {
          if (item.groupActivity) {
            this.shopItemInfo[String(JSON.parse(item.specJson).map((child) => child.value))] = item;
          }
        } else {
          this.shopItemInfo[String(JSON.parse(item.specJson).map((child) => child.value))] = item;
        }
      });

      JSON.parse(productSpecJson).forEach((item) => {
        Object.assign(item, { options: item.options.map((element) => ({ name: element })) });
        this.productSpecJson.push(item);
      });
      this.setDefault(productSkuOptions);
      this.checkItem();
    },
    // 默认一个可用的sku
    setDefault(productSkuRespVOList) {
      const defautIdx = [];
      const defautName = [];
      this.someOne = productSkuRespVOList
        ? productSkuRespVOList.find((item) => (item.isSetStock === 1 && item.availableStock > 0) || item.isSetStock === 0)
        : null;
      if (!this.someOne) return;
      this.productSpecJson.forEach((item) => {
        item.options.forEach((list, i) => {
          JSON.parse(this.someOne.specJson).forEach((m) => {
            if (list.name === m.value) {
              defautName.push(list.name);
              defautIdx.push(i);
            }
          });
        });
      });
      this.subIndex = defautIdx;
      this.selectArr = defautName;
      this.sendParentSkuId(this.someOne);
    },
    // 将选中的sku保存到vuex 中
    sendParentSkuId(sku) {
      const course = JSON.parse(JSON.stringify(this.courseInfo));
      course.productSkuId = sku.productSkuId; // 用于请求计价接口
      this.$emit('triggerChecked', course);
    },
  },
  created() {},
  mounted() {
    this.modifySkuRespVOList();
  },
};
</script>
<style lang="scss" scoped>
.course-list {
  padding: 0 36px;
  .course-name {
    // padding-bottom: 25px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    span {
      display: inline-block;
      width: 7px;
      height: 29px;
      background: linear-gradient(180deg, #ffae74 0%, #ff6c02 100%);
      border-radius: 5px;
      box-shadow: 0 4px 7px 0 rgba(196, 69, 6, 0.2);
    }
    b {
      padding-left: 18px;
      color: #333;
      font-weight: 500;
      font-size: 33px;
      line-height: 45px;
    }
  }
  .sku-name {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-start;
    span {
        padding-right: 25px;
      color: #333;
      font-weight: 400;
      font-size: 25px;
    }
    div {
      position: relative;
      display: inline-block;
      width: 181px;
      height: 65px;
      margin: 25px 25px 25px 0;
      padding: 0 5px;
      overflow: hidden;
      color: #333;
      font-weight: 400;
      font-size: 25px;
      line-height: 65px;
      text-align: center;
      background: #fff;
      border: 2px solid #eaeaea;
      border-radius: 7px;
      img {
        position: absolute;
        right: 0;
        bottom: 0;
        // display: none;
        width: 30px;
        height: auto;
      }
    }
    div:nth-child(5n) {
      margin-left: 73px;
    }
     div:nth-child(4n) {
      // margin-left: 73px;
      margin-right: 0;
    }
    .tabSelected {
      box-sizing: border-box;
      color: #ff6c02;
      background: rgba(255, 108, 2, 0.1);
      border: 2px solid rgba(255, 108, 2, 0.5);
      border-radius: 7px;
      pointer-events: none;
      img {
        display: block;
      }
    }
    .noneActive {
      color: #a5a5a5;
      background: #fafafa;
      border: 2px solid #eee;
      border-radius: 7px;

      img {
        display: none;
      }
    }
  }
}
</style>
